var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1896_1643",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 92
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1896_1643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3893 65.0681C36.04 65.0681 35.6881 64.9479 35.401 64.7033L25.5211 56.2886C25.1803 55.998 24.9844 55.5736 24.9844 55.1254C24.9844 54.6779 25.1812 54.2535 25.5211 53.9629L35.401 45.5482C36.0425 45.0011 37.0062 45.0787 37.5531 45.7204C38.0993 46.363 38.0226 47.3268 37.3802 47.8731L28.8661 55.1254L37.3802 62.3776C38.0226 62.9248 38.0993 63.8886 37.5531 64.5303C37.2507 64.8857 36.8213 65.0681 36.3893 65.0681Z",
    fill: "#20ACE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6135 65.0681C55.1816 65.0681 54.7521 64.8857 54.4505 64.5303C53.9035 63.8886 53.981 62.9248 54.6226 62.3776L63.137 55.1254L54.6226 47.8731C53.981 47.3268 53.9035 46.363 54.4505 45.7204C54.9967 45.0787 55.9612 45.0011 56.6019 45.5482L66.4821 53.9629C66.8229 54.2535 67.0188 54.6779 67.0188 55.1254C67.0188 55.5736 66.8229 55.998 66.4821 56.2886L56.6019 64.7033C56.3148 64.9479 55.9629 65.0681 55.6135 65.0681Z",
    fill: "#20ACE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.413 71.2091C42.306 71.2091 42.1981 71.1982 42.0894 71.1763C41.2473 71.0047 40.7079 70.2049 40.8853 69.3908L47.1726 40.5321C47.35 39.718 48.1765 39.1965 49.0195 39.3681C49.8616 39.5397 50.401 40.3387 50.2235 41.1536L43.9363 70.0123C43.7815 70.7221 43.1342 71.2091 42.413 71.2091Z",
    fill: "#20ACE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8019 87H10.1981C4.57525 87 0 82.4352 0 76.8232V16.1768C0 10.5657 4.57525 6 10.1981 6H81.8019C87.4248 6 92 10.5657 92 16.1768V76.8232C92 82.4352 87.4248 87 81.8019 87ZM10.1981 9.03139C6.25007 9.03139 3.03774 12.237 3.03774 16.1768V76.8232C3.03774 80.763 6.25007 83.9686 10.1981 83.9686H81.8019C85.7499 83.9686 88.9623 80.763 88.9623 76.8232V16.1768C88.9623 12.237 85.7499 9.03139 81.8019 9.03139H10.1981Z",
    fill: "#20ACE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4811 30.2704H1.51887C0.679761 30.2704 0 29.616 0 28.8083C0 28.0014 0.679761 27.3462 1.51887 27.3462H90.4811C91.3202 27.3462 92 28.0014 92 28.8083C92 29.616 91.3202 30.2704 90.4811 30.2704Z",
    fill: "#20ACE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0139 22.9609C23.3405 22.9609 21.1641 20.8612 21.1641 18.2822C21.1641 15.7024 23.3405 13.6035 26.0139 13.6035C28.6881 13.6035 30.8637 15.7024 30.8637 18.2822C30.8637 20.8612 28.6881 22.9609 26.0139 22.9609ZM26.0139 16.5604C25.0304 16.5604 24.2291 17.3326 24.2291 18.2822C24.2291 19.2318 25.0304 20.004 26.0139 20.004C26.9982 20.004 27.7987 19.2318 27.7987 18.2822C27.7987 17.3326 26.9982 16.5604 26.0139 16.5604Z",
    fill: "#20ACE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0217 22.9609C8.3475 22.9609 6.17188 20.8621 6.17188 18.2822C6.17188 15.7024 8.3475 13.6035 11.0217 13.6035C13.6959 13.6035 15.8716 15.7024 15.8716 18.2822C15.8716 20.8621 13.6959 22.9609 11.0217 22.9609ZM11.0217 16.5604C10.0382 16.5604 9.23691 17.3334 9.23691 18.2822C9.23691 19.2318 10.0382 20.004 11.0217 20.004C12.0061 20.004 12.8065 19.2318 12.8065 18.2822C12.8065 17.3334 12.0061 16.5604 11.0217 16.5604Z",
    fill: "#20ACE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7088 23.2533C38.0352 23.2533 35.8594 21.0887 35.8594 18.428C35.8594 15.7682 38.0352 13.6035 40.7088 13.6035C43.3832 13.6035 45.5591 15.7682 45.5591 18.428C45.5591 21.0887 43.3832 23.2533 40.7088 23.2533ZM40.7088 16.6522C39.7252 16.6522 38.9247 17.4486 38.9247 18.428C38.9247 19.4074 39.7252 20.2038 40.7088 20.2038C41.6932 20.2038 42.4937 19.4074 42.4937 18.428C42.4937 17.4486 41.6932 16.6522 40.7088 16.6522Z",
    fill: "#20ACE3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDev);
export default __webpack_public_path__ + "static/media/dev.8b5fb69736ef70afb7fff2f0ecf1a0d0.svg";
export { ForwardRef as ReactComponent };